export default `
query listPublishedLinks($container: ID!){
    listPublishedLinks(container:$container){
        items{
            publishedcontainer
            pcreated
        }
   } 
}
`